import script from "./sidebar-insights-properties.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-insights-properties.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__